// Composable where we determine if the app is running on a native platform or a web platform
// Will be extended with more platform specific logic later
export function usePlatform() {
  const isApp = !import.meta.server && Boolean((globalThis as any).Capacitor)

  const platform = import.meta.server
    ? 'web'
    : ((globalThis as any).Capacitor?.getPlatform?.() ?? 'web')

  const isiOSApp = platform == 'ios'
  const isAndroidApp = platform == 'android'
  // Only used for development
  const isCapacitorWebApp = isApp && platform == 'web'

  return {
    isApp,
    isiOSApp,
    isAndroidApp,
    isCapacitorWebApp,
    platform: platform as 'ios' | 'android' | 'web',
  }
}
